<template>
  <div class="loading-spinner" :class="sizeClass">
    <div class="spinner" :style="spinnerStyle">
      <div class="spinner-inner"></div>
    </div>
    <p v-if="message" class="loading-message">{{ message }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size: {
    type: String,
    default: 'medium',
    validator: (value) => ['small', 'medium', 'large'].includes(value)
  },
  message: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: '#007bff'
  },
  overlay: {
    type: Boolean,
    default: false
  }
})

const sizeClass = computed(() => `loading-spinner--${props.size}`)

const spinnerStyle = computed(() => ({
  borderTopColor: props.color
}))
</script>

<style scoped>
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.loading-spinner--small {
  padding: 20px;
}

.loading-spinner--medium {
  padding: 40px;
}

.loading-spinner--large {
  padding: 60px;
}

.spinner {
  border-radius: 50%;
  animation: spin 1s linear infinite;
  position: relative;
}

.loading-spinner--small .spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
}

.loading-spinner--medium .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
}

.loading-spinner--large .spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #007bff;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-message {
  color: #6c757d;
  font-size: 0.9em;
  margin: 0;
  text-align: center;
}

.loading-spinner--small .loading-message {
  font-size: 0.8em;
}

.loading-spinner--large .loading-message {
  font-size: 1em;
}
</style> 